<template>
  <button class="btn-add" @click="addMeal()">
    <Icon icon="fa fa-plus" text="Ajouter un repas" />
  </button>
</template>

<script>
import MealForm from './MealForm.vue';

export default {
  props: {
    isChooseView: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    addMeal() {
      // callback: fonction pour ajouter direct au jour (choose)
      let callback = null;
      if (this.isChooseView) {
        callback = (meal) => {
          // On a crée un nouveau meal, on fait comme si on avait cliqué dessus
          this.$emit('click', meal);
        };
      }
      // Open popup to add a meal
      this.$modal.show(
        MealForm,
        {
          onChoose: callback,
        },
        {
          height: 'auto',
          width: this.isMediumScreen ? '95%' : '600px',
          clickToClose: true,
        }
      );

      // Envoie du fait qu'on a cliqué au parent
      this.$emit('popup-opened');
    },
  },
  computed: {},
};
</script>

<style lang="scss" scoped src="./AddMealButton.scss"></style>
